import { CustomerModel, CustomerModels } from 'pages/Customers/helpers/types'
import { SourceWalletTypes } from 'types/move/move'
import { WalletTransferType } from 'types/unifiedPayouts/unifiedPayouts'

export const checkIsPrincipalWallet = (walletType?: string): boolean => {
  return walletType === SourceWalletTypes.MAIN
}

export const checkIsEmbeddedOrRelianceModel = (customerModel?: CustomerModel): boolean => {
  return customerModel === CustomerModels.EMBEDDED || customerModel === CustomerModels.RELIANCE
}

export const checkIsCustomerWalletTransferType = (
  walletTransferType?: WalletTransferType
): boolean => {
  return walletTransferType === WalletTransferType.CUSTOMER
}

export const checkIsWalletTransferTypeEnabled = ({
  isEmbeddedOrRelianceModel,
  isPrincipalWallet,
  isCryptoWallet,
  isEpcCapabilityEnabled,
}: {
  isEmbeddedOrRelianceModel: boolean
  isPrincipalWallet: boolean
  isCryptoWallet: boolean
  isEpcCapabilityEnabled: boolean
}): boolean => {
  return (
    !isEmbeddedOrRelianceModel ||
    isPrincipalWallet ||
    (isEmbeddedOrRelianceModel && isEpcCapabilityEnabled && !isCryptoWallet && !isPrincipalWallet)
  )
}

export const checkIsTransferTypeSelected = (walletTransferType?: WalletTransferType): boolean => {
  if (!walletTransferType) return false

  if (
    walletTransferType === WalletTransferType.MAIN ||
    walletTransferType === WalletTransferType.CUSTOMER
  ) {
    return true
  }

  return false
}

export const checkRequiresCustomerReference = ({
  isCustomerWalletTransferType,
  customerReference,
}: {
  isCustomerWalletTransferType: boolean
  customerReference?: string
}): boolean => {
  return isCustomerWalletTransferType && !customerReference
}

export const checkShowDestinationWalletCombobox = ({
  isTransferTypeSelected,
  hasTransferWallets,
  requiresCustomerReference,
}: {
  isTransferTypeSelected: boolean
  hasTransferWallets: boolean
  requiresCustomerReference: boolean
}): boolean => {
  return isTransferTypeSelected && hasTransferWallets && !requiresCustomerReference
}

export const checkShowNoWalletsCallout = ({
  isLoading,
  hasTransferWallets,
  walletTransferType,
  sourceWalletId,
  customerReference,
  isCustomerWalletTransferType,
}: {
  isLoading: boolean
  hasTransferWallets: boolean
  walletTransferType?: WalletTransferType
  sourceWalletId?: string
  customerReference?: string
  isCustomerWalletTransferType: boolean
}): boolean => {
  if (isLoading || hasTransferWallets) {
    return false
  }

  if (walletTransferType === WalletTransferType.MAIN) {
    return !!sourceWalletId
  }

  return isCustomerWalletTransferType && !!customerReference
}

export const checkShowContent = ({
  isLoading,
  hasTransferWallets,
  destinationWallet,
  isTransferTypeSelected,
  requiresCustomerReference,
}: {
  isLoading: boolean
  hasTransferWallets: boolean
  destinationWallet?: string
  isTransferTypeSelected: boolean
  requiresCustomerReference: boolean
}): boolean => {
  return (
    !isLoading &&
    hasTransferWallets &&
    !!destinationWallet &&
    isTransferTypeSelected &&
    !requiresCustomerReference
  )
}
